    <!-- 我们的产品 -->
<template>
    <div v-if="isPc">
        <el-row  type="flex" justify="center">
            <el-col :span="16">
                <el-row :gutter="20" type="flex" justify="center" >
                        <el-col :span="8" align="center" v-for="(item,index) in productIconList" :key=index >
                            <div class="divimage2" :class="{'animated zoomIn': isShowIcon}" ref="ref1">
                            <el-image
                                :src=item.url
                                class="sceneimage image-transition-scale2">
                            </el-image>
                            </div>
                            <div class="divp">
                                <p class="font-16">{{item.title}}</p>
                            </div>
                        </el-col>
                    </el-row>
            </el-col>
        </el-row>
    </div>
    <!-- 移动端适配 -->
   <div v-else>
    <el-row :gutter="20"  type="flex" justify="center" v-for="i in 3" :key=i>
            <el-col :span="24"  v-for="(item,index) in productIconList.slice((i-1)*1,i*1)" :key=index  align="center">
              <el-card>
                <div class="divimage3">
                  <el-image
                    :src=item.url
                    class="sceneimage image-transition-scale2">
                  </el-image>
                </div>
                    <div class="div-icon-p">
                       <p class="font-14">{{item.title}}</p>
                  </div>
              </el-card>
            </el-col>
      </el-row>
    </div>
</template>
<script>
import {mapState} from "vuex"
export default {
    name:"HomeProduct",
    data(){
        return{
            productIconList:[
                 {
                    url:require('@/assets/images/product_icon_01.png'),
                    title:'智能装备'
                 }, {
                    url:require('@/assets/images/product_icon_02.png'),
                    title:'物料逐支跟踪'
                 },
                    {
                    url:require('@/assets/images/product_icon_03.png'),
                    title:'集控中心'
                 }
            ],
            isShowIcon:true,
       }
    },
    mounted(){
       // 监听鼠标滚动事件
       document.addEventListener("scroll", this.handleScroll);
    },
    props:{

    },
    methods:{
      handleScroll() {
      // 实现当滚动到指定位置，触发动画
      let _this = this;
      let refArray = [
        { ref: "ref1", show: "isShowIcon" },
      ];
      refArray.forEach((r) => {
        _this.gdjz(r.ref, 200, () => {
          _this[r.show] = false;
          setTimeout(() => {
            _this[r.show] = true;
          }, 100);
        });
      });
    },
    gdjz(div, offset, callback) {
      //offset暂时未使用
      let dom = this.$refs[div];
      if (dom) {
        let b =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop; //  获取窗口滚动条高度
        // c = document.documentElement.clientHeight || document.body.clientHeight // 获取浏览器可视区的高度
        if (div == "ref1") {
          if ( (b >= 400 && b <= 450) || (b >= 2050 && b <= 2100)) {
            callback && callback();
          }
        }  
      }
     }
    },
    computed:{
         ...mapState(['isPc'])
    }
}
</script>

<style scoped>
 .divimage2 {
  height: 150px;
  width: 100%;
  overflow: hidden;
}
 .divimage3 {
  height: 80px;
  width: 80px;
  overflow: hidden;
}
.divp{
  margin:30px 0 30px 0;
}
 .div-icon-p{
  margin:20px 0 20px 0;
}
</style>
